import React from "react";
import { LangSwitcher } from "../LangSwitcher";

interface Props {
  title: string;
  onBack: () => void;
  backLabel: string;
}

const BookingHeader: React.FC<Props> = ({ title, onBack, backLabel }) => (
  <nav className="pab-nav">
    <button className="pab-nav__back" onClick={onBack} aria-label={backLabel}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 18l-6-6 6-6" />
      </svg>
      <span>{backLabel}</span>
    </button>
    <span className="pab-nav__title">{title}</span>
    <LangSwitcher />
  </nav>
);

export default BookingHeader;
